import Axios from 'axios';
import APIRoutes from '@/API/ApiRoutes';


const state = {

};

const getters = {

};

const actions = {
  getUserList({commit},payload){
    return new Promise(function (resolve,reject) {
      let user = APIRoutes.BASEURL+ APIRoutes.PORT+'/oauth/token';
      /*let user = APIRoutes.BASEURL+'/oauth/token';*/
      console.log('assd',user);
      Axios.get(user,{
        headers:{
          'grant_type': 'Bearer',
          'client_id' : '2',
          'client_secret':'cEfaCbnoQzDFJqfAAC2kPpEkZQJpOKJ2Hd0ZtQ9v',
          'username':'+8801676342090',
          'password': 'bdnbd'
        }
      }).then(function (response) {

      });
    });
  },

  logIn({commit},payload){
    return new Promise(function (resolve,reject) {
      let end_point = APIRoutes.BASEURL+ APIRoutes.PORT+'/oauth/token';
      /*let end_point = APIRoutes.BASEURL+'/oauth/token';*/
      Axios.post(end_point,{
        headers:{
          'grant_type': 'Bearer',
          'client_id' : '2',
          'client_secret':'cEfaCbnoQzDFJqfAAC2kPpEkZQJpOKJ2Hd0ZtQ9v',
          'username':'+8801676342090',
          'password': 'bdnbd'
        }
      }).then(function (response) {
          if(response.data){
            resolve(response);
            console.log(this.response);
          }
          else {
            resolve(response);
          }

      }).catch( function (error) {
          reject(error);

      });
    });
  }
};

const mutations = {


};

export default {
  state,
  getters,
  actions,
  mutations
};
